// ======================================================================
// File Name       : ScoringReportListSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, InputGroup, Button } from 'react-bootstrap';
import { VALIDATE_TYPE, RETURN_MAX_NUM } from '../../../constants/index';
import RenderField from '../../../utils/ReduxFormUtils';
import * as ReportConstants from '../../../constants/ScoringReportConstants';
import { MANAGEMENT_AUTHORITY_TYPE } from '../../../constants/AuthorityConstant';
import { convertNodeGroupToNodeString } from '../../../utils/UserUtils';
import DateTimeMinMax from '../../DateTimeMinMax';
import CustomButton from '../../button/CustomButton';

class ReportListSearch extends React.Component {
  render() {
    const {
      reportName,
      userSubmitter,
      groupSubmitter,
      noSetCheckerFlg,
      submitted,
      checking,
      remand,
      pendingApproval,
      approved,
      resultReturned,
      checkerName,
      includeDeadlineReportFlg,
      selectedTargetGroup,
      reportId,
      displayDate,
      submissionDateFrom,
      submissionDateTo,
      updatedDateFrom,
      updatedDateTo,
    } = this.props.searchInfo;
    this.refsToValidate = [];
    const scoringManagementAuthority = this.props.scoringManagementAuthority;
    const { onShowGroupDialog, mode, onSearchReport, onRadioButtonChange } = this.props;
    const isDiableStatus = mode != ReportConstants.REPORT_LIST_MODE.TOP;
    let isDiableStatusOfCheckerUser = false;
    if (scoringManagementAuthority === MANAGEMENT_AUTHORITY_TYPE.REFERENCE) {
      isDiableStatusOfCheckerUser = true;
    }
    const isDiableChecker = mode == ReportConstants.REPORT_LIST_MODE.GET;
    let groupName = null;
    if (this.props.groupList && selectedTargetGroup && selectedTargetGroup.groupSecernId) {
      const groupSecernId = selectedTargetGroup.groupSecernId;
      groupName = convertNodeGroupToNodeString(groupSecernId, this.props.groupList);
    }
    return (
      <div>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            onSearchReport();
          }}
          className='form-horizontal'
        >
          <Col sm={12}>
            {/* #5854 START */}
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={4}>
              添削管理ID
              </Col>
              <Col sm={8} className="padding-right-15">
                <RenderField
                  type="text"
                  name="reportId"
                  label="添削管理ID"
                  maxLength="256"
                  value={reportId}
                />
              </Col>
            </Form.Group>
            {/* #5854 END */}
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={4}>
                レポート名
              </Col>
              <Col sm={8} className="padding-right-15">
                <RenderField type="text" name="reportName" label="レポート名" maxLength="256" value={reportName} />
              </Col>
            </Form.Group>
            {scoringManagementAuthority === MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT && (
              <Form.Group className="form-info">
                <Col as={Form.Label} sm={4}>
                  ユーザー名(提出者)
                </Col>
                <Col sm={8} className="padding-right-15">
                  <RenderField type="text" name="userSubmitter" maxLength="40" value={userSubmitter} />
                </Col>
              </Form.Group>
            )}
            {scoringManagementAuthority === MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT && (
              <Form.Group className="form-info">
                <Col as={Form.Label} sm={4}>
                  所属グループ(提出者)
                </Col>
                <Col sm={2} className="padding-right-15">
                  <Button variant="primary" className="btn-96" onClick={onShowGroupDialog}>
                    グループ選択
                  </Button>
                </Col>
              </Form.Group>
            )}
            {groupSubmitter && (
              <Form.Group className="form-info" controlId="formHorizontalGroup">
                <Col sm={4}>
                </Col>
                <Col sm={6} as={Form.Label}>
                  {groupName}
                </Col>
                <Col sm={2}>
                  <Button variant="primary" className="btn-96" onClick={this.props.removeSelectedGroup}>
                    削除
                  </Button>
                </Col>
              </Form.Group>
            )}
            {scoringManagementAuthority === MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT && (
              <Form.Group className="form-info">
                <Col as={Form.Label} sm={4}>
                  添削者名
                </Col>
                <Col sm={8} className="padding-right-15">
                  <RenderField
                    type="text"
                    name="checkerName"
                    maxLength="40"
                    value={checkerName}
                    disabled={isDiableChecker}
                  />
                </Col>
              </Form.Group>
            )}
            {scoringManagementAuthority === MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT && (
              <Form.Group className="form-info">
                <Col as={Form.Label} sm={4}>
                  添削者未割当てのレポートを含む
                </Col>
                <Col sm={8} className="padding-top-10">
                  <RenderField
                    className="padding-top-clear"
                    name="noSetCheckerFlg"
                    value={noSetCheckerFlg}
                    type="checkbox"
                    disabled={isDiableChecker}
                    checked={noSetCheckerFlg}
                  />
                </Col>
              </Form.Group>
            )}
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={4}>
                レポートステータス
              </Col>
              <Col sm={8}>
                <Col sm={4}>
                  <Col sm={12} className="padding-clear">
                    <RenderField
                      name="submitted"
                      value={submitted}
                      type="checkbox"
                      disabled={isDiableStatus}
                      label="提出済み"
                    />
                  </Col>
                  <Col sm={12} className="padding-clear">
                    <RenderField
                      name="pendingApproval"
                      value={pendingApproval}
                      type="checkbox"
                      disabled={isDiableStatus}
                      label="承認待ち"
                    />
                  </Col>
                </Col>
                <Col sm={4} className="padding-clear">
                  <Col sm={12} className="padding-clear">
                    <RenderField name="checking" value={checking} type="checkbox" disabled={isDiableStatus} label="添削中" />
                  </Col>
                  <Col sm={12} className="padding-clear">
                    <RenderField
                      name="approved"
                      value={approved}
                      type="checkbox"
                      disabled={isDiableStatus || isDiableStatusOfCheckerUser}
                      label="承認済み"
                    />
                  </Col>
                </Col>
                <Col sm={4} className="padding-clear">
                  <Col sm={12} className="padding-clear">
                    <RenderField name="remand" value={remand} type="checkbox" disabled={isDiableStatus} label="差し戻し" />
                  </Col>
                  <Col sm={12} className="padding-clear">
                    <RenderField
                      name="resultReturned"
                      value={resultReturned}
                      type="checkbox"
                      disabled={isDiableStatus || isDiableStatusOfCheckerUser}
                      label="結果返却済み"
                    />
                  </Col>
                </Col>
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={4}>
                提出期限切れレポートを含む
              </Col>
              <Col sm={7} className="padding-top-10">
                <RenderField
                  className="padding-top-clear"
                  type="checkbox"
                  name="includeDeadlineReportFlg"
                  value={includeDeadlineReportFlg}
                />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col sm={4} as={Form.Label}>
                <RenderField
                  inline
                  type="radio"
                  label="レポート提出日"
                  className="padding-top-clear"
                  name="displayDate"
                  radioChange={onRadioButtonChange}
                  checkRadioChange
                  value={MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT}
                  normalizeRadio
                />
              </Col>
              <Col sm={3}>
                <RenderField
                  name="submissionDateFrom"
                  type="datetime"
                  shouldDisabledCurrentAndAfter
                  isShowDateInput={false}
                  disabled={displayDate != MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT}
                  validates={[VALIDATE_TYPE.DATE_TIME]}
                  normalizeDateTime
                />
              </Col>
              <Col sm={1} className="text-center" as={Form.Label}>
                ～
              </Col>
              <Col sm={3}>
                <RenderField
                  name="submissionDateTo"
                  disabled={displayDate != MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT}
                  type="datetime"
                  shouldDisabledCurrentAndAfter
                  isShowDateInput={false}
                  validates={[VALIDATE_TYPE.DATE_TIME]}
                  normalizeDateTime
                />
              </Col>
              <Col sm={12}>
                <DateTimeMinMax
                  shouldValidateRange
                  dateFrom={submissionDateFrom}
                  dateTo={submissionDateTo}
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col sm={4} as={Form.Label}>
                <RenderField
                  inline
                  type="radio"
                  className="padding-top-clear"
                  label="レポート更新日"
                  name="displayDate"
                  radioChange={onRadioButtonChange}
                  checkRadioChange
                  value={MANAGEMENT_AUTHORITY_TYPE.REFERENCE}
                  normalizeRadio
                />
              </Col>
              <Col sm={3}>
                <RenderField
                  name="updatedDateFrom"
                  type="datetime"
                  shouldDisabledCurrentAndAfter
                  isShowDateInput={false}
                  disabled={displayDate != MANAGEMENT_AUTHORITY_TYPE.REFERENCE}
                  validates={[VALIDATE_TYPE.DATE_TIME]}
                  normalizeDateTime
                />
              </Col>
              <Col sm={1} className="text-center" as={Form.Label}>
                ～
              </Col>
              <Col sm={3}>
                <RenderField
                  name="updatedDateTo"
                  disabled={displayDate != MANAGEMENT_AUTHORITY_TYPE.REFERENCE}
                  type="datetime"
                  shouldDisabledCurrentAndAfter
                  isShowDateInput={false}
                  validates={[VALIDATE_TYPE.DATE_TIME]}
                  normalizeDateTime
                />
              </Col>
              <Col sm={12}>
                <DateTimeMinMax
                  shouldValidateRange
                  dateFrom={updatedDateFrom}
                  dateTo={updatedDateTo}
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                />
              </Col>
            </Form.Group>
          </Col>
          <hr />
          <Col sm={12} className="text-center margin-top-10">
            <CustomButton
              btnStyle="btn btn-primary btn-96"
              type="submit"
              text="検索"
              iconClass="bi bi-search"
            />
          </Col>
        </Form>
      </div>
    );
  }
}
export default ReportListSearch;
